import * as types from "../config/actionTypes";
import axios from "axios";
import Flagship from "../core/flagship";
import { actions } from "react-redux-form";
import { browserHistory } from "react-router";
import LogRocket from "logrocket";
import { addTimerEventListeners } from "../utils/timetracking";

export function login(payload, redirect = "/") {
  return function (dispatch) {
    // thunk
    let url = Flagship.config.apiBase + "login";

    dispatch(actions.change("login.failed", false));
    axios
      .post(url, payload)
      .then(function (response) {
        if (response.data.success === true) {
          browserHistory.push(redirect);
          addTimerEventListeners(
            response.data,
            dispatch,
            "You still have a timer running.",
            response.data.timer_start !== null
          );

          LogRocket.identify(response.data.username, {
            name: response.data.first_name + " " + response.data.last_name,
            email: response.data.email,
            subscriptionType: "pro",
            userRole: response.data.role,
            userMarket: response.data.market,
            userInstance: response.data.instance,
            userViewAs: response.data.view_preference,
          });

          return dispatch({
            type: types.LOGIN,
            token: response.data.token,
            accessLevel: response.data.accessLevel,
            userId: response.data.userId,
            username: response.data.username,
            userFirstName: response.data.first_name,
            userLastName: response.data.last_name,
            userPhoto: response.data.photo,
            userRole: response.data.role,
            userMarket: response.data.market,
            userInstance: response.data.instance,
            userViewAs: response.data.view_preference,
            timeTracking: response.data.time_tracking,
          });
        } else {
          dispatch(actions.change("login.message", response.data.message));
          dispatch(actions.change("login.failed", true));
        }
      })
      .catch(function (err) {
        return dispatch(
          actions.change("login.message", "The Flagship API is down. " + err)
        );
      });
  };
}

export function checkToken(token) {
  return function (dispatch) {
    // thunk
    let url = Flagship.config.apiBase + "validate-token";

    axios
      .post(url, { token })
      .then(function (response) {
        if (response.data.success === true) {
          addTimerEventListeners(
            response.data,
            dispatch,
            "You have a timer running."
          );

          LogRocket.identify(response.data.username, {
            name: response.data.first_name + " " + response.data.last_name,
            email: response.data.email,
            subscriptionType: "pro",
            userRole: response.data.role,
            userMarket: response.data.market,
            userInstance: response.data.instance,
            userViewAs: response.data.view_preference,
          });

          return dispatch({
            type: types.VALID_TOKEN,
            token: response.data.token,
            accessLevel: response.data.accessLevel,
            userId: response.data.userId,
            username: response.data.username,
            userFirstName: response.data.first_name,
            userLastName: response.data.last_name,
            userPhoto: response.data.photo,
            userRole: response.data.role,
            userMarket: response.data.market,
            userInstance: response.data.instance,
            userViewAs: response.data.view_preference,
            timeTracking: response.data.time_tracking,
          });
        } else {
          browserHistory.push("/login");

          return dispatch({
            type: types.INVALID_TOKEN,
            token: response.data.token,
          });
        }
      })
      .catch(function () {
        browserHistory.push("/login");
      });
  };
}

export function logout() {
  clearInterval(window.timer);
  return function (dispatch) {
    dispatch({
      type: types.LOGOUT,
    });
  };
}

export function clearErrors() {
  return function (dispatch) {
    dispatch({
      type: types.CLEAR_ERRORS,
    });
  };
}

export function clearNotification() {
  return function (dispatch) {
    dispatch({
      type: types.CLEAR_NOTIFICATION,
    });
  };
}

export function resizeWindow(size) {
  return function (dispatch) {
    dispatch({
      type: types.RESIZE_WINDOW,
      size,
    });
  };
}

export function changeInstance(instance = "Standard") {
  return function (dispatch) {
    dispatch({
      type: types.CHANGE_INSTANCE,
      instance,
    });
  };
}

export function changeViewAs(viewAs = "cards") {
  return function (dispatch) {
    dispatch({
      type: types.CHANGE_VIEW_AS,
      viewAs,
    });
  };
}

export function trackTime(userId, start = 0) {
  return function (dispatch) {
    dispatch({
      type: "START_TIMER",
      start,
    });

    clearInterval(window.timer);
    window.timer = setInterval(function () {
      dispatch({
        type: "INCREMENT_TIMER",
      });
    }, 1000);
  };
}

export function stopTrackTime() {
  return function (dispatch) {
    clearInterval(window.timer);

    dispatch({
      type: "STOP_TIMER",
    });
  };
}

export function clearTime() {
  return function (dispatch) {
    dispatch({
      type: "CLEAR_TIMER",
    });
  };
}

export function clearTimeOnly() {
  return function (dispatch) {
    dispatch({
      type: "CLEAR_TIME_ONLY",
    });
  };
}

export function toggleClientPicker(value) {
  return function (dispatch) {
    dispatch({
      type: "PICKING_CLIENT",
      value,
    });
  };
}

export function pickClient(client) {
  return function (dispatch) {
    dispatch({
      type: "PICK_CLIENT",
      client,
    });
  };
}

export function toggleTaskPicker(value) {
  return function (dispatch) {
    dispatch({
      type: "PICKING_TASK",
      value,
    });
  };
}

export function pickTask(task) {
  return function (dispatch) {
    dispatch({
      type: "PICK_TASK",
      task,
    });
  };
}

export function toggleTimeTracker(force = null) {
  return function (dispatch) {
    dispatch({
      type: "TOGGLE_TIMER",
      force,
    });
  };
}

export function globalSearch(search = "") {
  return function (dispatch) {
    dispatch({
      type: "GLOBAL_SEARCH",
      search,
    });
  };
}

export function setClientIntoStore(recordType, recordId, isAdvisr = false) {
  return function (dispatch) {
    Flagship.get(
      "record-client/" + recordType + "/" + recordId,
      { isAdvisr },
      function (response) {
        dispatch({
          type: "STORE_CLIENT",
          data: response.data,
        });
      }
    );
  };
}

export function clearDefaultClient() {
  return function (dispatch) {
    dispatch({
      type: "CLEAR_DEFAULT_CLIENT",
    });
  };
}

export function usePreviousTimesheet(data) {
  return function (dispatch) {
    dispatch({
      type: "USE_PREVIOUS_TIMESHEET",
      data,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/appActions.js